export default {
  reset(state) {
    state.withdrawalPayment = {}
  },
  setCpsPaymentList(state, value) {
    state.cpsPaymentList = value
  },
  setWithdrawalPayment(state, value) {
    state.withdrawalPayment = value
  },
  setWithdrawalAmount(state, value) {
    state.withdrawalAmount = value
  },
}
